module.exports = __webpack_public_path__ + "static/media/Walmart_Spark.927529f8.svg";